import { render } from "./Policylist.vue?vue&type=template&id=f52b90c4&scoped=true"
import script from "./Policylist.vue?vue&type=script&lang=js"
export * from "./Policylist.vue?vue&type=script&lang=js"

import "./Policylist.vue?vue&type=style&index=0&id=f52b90c4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f52b90c4"]])

export default __exports__